import React from 'react';
import { Rule } from '../../types/rule';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import BlockIcon from '@mui/icons-material/Block';
import DoneIcon from '@mui/icons-material/Done';
import useConfigStyles from '../../components/useConfigStyles';

type JobRulesProps = {
  rules: Rule[];
  editable: boolean;
  removeRule: (rule: Rule) => void;
};

function JobRules({ rules, editable, removeRule }: JobRulesProps): JSX.Element {
  const classes = useConfigStyles();
  const handleOnDelete = (rule: Rule) => {
    removeRule(rule);
  };

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className='table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>Rule</TableCell>
            <TableCell align='center'>Severity</TableCell>
            <TableCell align='center'>Enabled</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rules.map((rule) => (
            <TableRow key={rule.Name}>
              <TableCell component='th' scope='row'>
                {rule.Name}
              </TableCell>
              <TableCell align='center'>{rule.Severity}</TableCell>
              <TableCell align='center'>{!rule.Disabled ? <DoneIcon /> : <BlockIcon />}</TableCell>
              <TableCell align='center'>
                {editable && (
                  <IconButton color='secondary' onClick={() => handleOnDelete(rule)}>
                    <DeleteIcon />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default JobRules;
